import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { defaultPaginationConfig } from '@spartacus/storefront';
import { I18nModule, provideDefaultConfig } from '@spartacus/core';
import { NyabPaginationComponent } from './nyab-pagination.component';



@NgModule({
    imports: [CommonModule, RouterModule, I18nModule, NyabPaginationComponent],
    providers: [provideDefaultConfig(defaultPaginationConfig)],
    exports: [NyabPaginationComponent],
})
export class NyabPaginationModule { }
